<mat-card class="card" [style.width]="'600px'" [style.height]="'750px'" [style.border-radius]="'5%'">
    <mat-card-content>
      <ng-content></ng-content>
    </mat-card-content>
</mat-card>